export const CASH_FLOWS_INIT = 'CASH_FLOWS_INIT';
export const REDUCE_CASH_FLOWS_INIT = 'REDUCE_CASH_FLOWS_INIT';
export const REDUCE_CASH_FLOW_STATS_INIT = 'REDUCE_CASH_FLOW_STATS_INIT';
export const REDUCE_CASH_FLOW_CATEGORY_RENAME = 'REDUCE_CASH_FLOW_CATEGORY_RENAME';
